module.exports = __webpack_public_path__ + "static/media/good.6e8e971b.png";